<ng-container [ngTemplateOutlet]="selectedTemplate()"/>

<ng-template #basicTemplate>
  <app-ui-kpi-small [count]="count$ | async" [text]="config()?.title" [isLoading]="isLoading()"
                    [badgeConfig]="config()?.badgeConfig"
                      [isClickable]="config()?.isClickable ?? true" (clicked)="config()?.callbackFn?.(config())">
    </app-ui-kpi-small>
</ng-template>

<ng-template #ratioTemplate>
  <app-ui-kpi-small-ratio [data]="data$ | async" [text]="config()?.title" [isLoading]="isLoading()"
                          [badgeConfig]="config()?.badgeConfig"
                            [isClickable]="config()?.isClickable ?? true" (clicked)="config()?.callbackFn?.(config())">
    </app-ui-kpi-small-ratio>
</ng-template>
